document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.section-become-member__tab-button');
  const tabContents = document.querySelectorAll('.section-become-member__tab-content');

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const tabName = button.getAttribute('data-tab');

      // Deactivate all tabs
      tabButtons.forEach((btn) => btn.classList.remove('section-become-member__tab-button--active'));
      tabContents.forEach((content) => content.classList.remove('section-become-member__tab-content--active'));

      // Activate selected tab
      button.classList.add('section-become-member__tab-button--active');
      document.querySelector(`.section-become-member__tab-content[data-tab="${tabName}"]`)?.classList.add('section-become-member__tab-content--active');
    });
  });
});
